module.exports = __webpack_public_path__ + "img/homepic.eccedf85.png";